$(document).ready(function(){
  $('.testimonial-slider').slick({
  slidesToShow: 4,
  dots:false,
  centerMode: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    },
      {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
      {
      breakpoint: 1200,
      settings: {
        slidesToShow:3
      }
    },
     {
      breakpoint:1440,
      settings: {
        slidesToShow:3
      }
    }
  ]
  });
  
});

// Slick version 1.5.8